var _defs, _rect, _rect2, _g, _g2, _polygon, _rect3, _g3, _g4, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 593.96 140.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffd504;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #161413;\n      }\n\n      .cls-4 {\n        fill: #e10814;\n      }\n\n      .cls-5 {\n        fill: #23afe5;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 70.6,
    width: 426.83,
    height: 69.68
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 426.84,
    height: 70.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.11,62.42V10.27h40.97v10.75h-26.54v11.73h24.56v10.19h-24.56v19.47h-14.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.11,62.42V10.27h41.51v10.75h-27.07v9.7h24.38v10.19h-24.38v10.75h27.07v10.76h-41.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.74,43.93h14.43c.27,5.3,2.51,8.8,10.85,8.8,7.44,0,9.23-2.77,9.23-5.21,0-10.76-33.53-2.04-33.53-22.16,0-7.99,5.29-15.81,23.49-15.81s23.22,7.82,23.49,18.42h-14.34c-.27-4.4-1.7-7.99-9.77-7.99-6.72,0-8.43,2.44-8.43,4.64,0,9.53,33.17,1.55,33.17,22.16,0,7.5-4.39,16.38-24.12,16.38-17.84,0-24.47-7.25-24.47-19.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M188.59,62.42V21.03h-14.43v-10.75h43.21v10.75h-14.43v41.39h-14.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.95,62.42V10.27h14.52v52.15h-14.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M269.17,62.42l-20.17-52.15h15.24l13.98,40.58,14.34-40.58h15.24l-20.62,52.15h-18.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M306.01,62.42l20.26-52.15h18.29l20.26,52.15h-15.24l-3.14-8.96h-22.05l-3.14,8.96h-15.24,0ZM327.53,43.76h15.78l-7.98-22-7.8,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.88,62.42V10.27h14.61l-.18,41.39h19.1v10.76h-33.53Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.95,131.79l20.39-52.5h18.41l20.39,52.5h-15.34l-3.16-9.02h-22.2l-3.16,9.02h-15.34ZM36.6,113h15.88l-8.03-22.15-7.85,22.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.37,131.79v-52.5h21.02l12.63,33.55c.81,2.13,1.53,4.59,1.8,5.66.27-1.07.81-3.53,1.63-5.66l12.99-33.55h20.84v52.5h-14.71v-36.01l-13.72,36.01h-13.99l-13.99-36.01v36.01h-14.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.92,131.79v-52.5h41.78v10.83h-27.25v9.76h24.54v10.25h-24.54v10.83h27.25v10.83h-41.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.89,131.79v-52.5h22.11c22.2,0,24.36,10.66,24.36,17.56,0,5.83-2.17,14.93-15.97,15.67l18.5,19.28h-17.87l-16.51-19.85v19.85h-14.62ZM227.51,103.4h7.31c8.03,0,9.75-3.53,9.75-6.56,0-3.28-1.71-6.73-9.75-6.73h-7.31v13.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268.74,131.79v-52.5h14.62v52.5h-14.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.82,105.53c0-13.95,4.78-26.99,27.07-26.99,19.58,0,26.44,10.01,26.44,21.49h-14.8c-.9-6.89-3.7-10.58-11.64-10.58-10.56,0-12.27,7.14-12.27,16.08s1.62,16.08,12.27,16.08c8.03,0,10.74-3.53,11.64-10.66h14.89c0,12.14-6.86,21.57-26.53,21.57-22.38,0-27.07-13.04-27.07-26.99h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M349.3,131.79l20.39-52.5h18.41l20.39,52.5h-15.34l-3.16-9.02h-22.2l-3.16,9.02h-15.34ZM370.96,113h15.88l-8.03-22.15-7.85,22.15h0Z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "593.95 86.58 426.83 86.58 426.83 0 593.88 0 593.95 86.58"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 426.83,
    y: 86.52,
    width: 167.13,
    height: 53.74
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M440.82,23.21v-12.74h3.57l-.04,10.11h4.66v2.63h-8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M450.54,23.21v-12.74h3.54v12.74h-3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M459.08,23.21v-10.11h-3.52v-2.63h10.55v2.63h-3.53v10.11h-3.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M470,23.21v-10.11h-3.52v-2.63h10.55v2.63h-3.53v10.11h-3.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M478.5,23.21v-12.74h10.13v2.63h-6.61v2.37h5.95v2.49h-5.95v2.63h6.61v2.63h-10.13ZM479.22,9.45v-2.29l8.69-1.31v2.29l-8.69,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M490.65,23.21v-12.74h5.36c5.38,0,5.91,2.59,5.91,4.26,0,1.41-.53,3.62-3.87,3.8l4.49,4.68h-4.34l-4.01-4.82v4.82h-3.55ZM494.2,16.32h1.77c1.95,0,2.36-.86,2.36-1.59,0-.8-.42-1.63-2.36-1.63h-1.77v3.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M502.46,23.21l4.95-12.74h4.47l4.95,12.74h-3.72l-.77-2.19h-5.38l-.77,2.19h-3.72ZM507.71,18.65h3.85l-1.95-5.38-1.9,5.38h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M519.14,23.21v-10.11h-3.52v-2.63h10.55v2.63h-3.53v10.11h-3.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M527.42,17.55v-7.09h3.57v7.05c0,2.09.44,3.19,2.67,3.19s2.67-1.1,2.67-3.19v-7.05h3.59v7.09c0,4.08-1.84,5.83-6.26,5.83s-6.24-1.75-6.24-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M542.24,23.21v-12.74h5.36c5.38,0,5.91,2.59,5.91,4.26,0,1.41-.53,3.62-3.87,3.8l4.49,4.68h-4.34l-4.01-4.82v4.82h-3.55ZM545.79,16.32h1.77c1.95,0,2.36-.86,2.36-1.59,0-.8-.42-1.63-2.36-1.63h-1.77v3.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M555.58,23.21v-12.74h10.13v2.63h-6.61v2.37h5.95v2.49h-5.95v2.63h6.61v2.63h-10.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M567.32,18.69h3.52c.07,1.29.61,2.15,2.65,2.15,1.82,0,2.25-.68,2.25-1.27,0-2.63-8.19-.5-8.19-5.42,0-1.95,1.29-3.86,5.74-3.86s5.67,1.91,5.73,4.5h-3.5c-.07-1.08-.42-1.95-2.39-1.95-1.64,0-2.06.6-2.06,1.14,0,2.33,8.1.38,8.1,5.41,0,1.83-1.07,4-5.89,4-4.36,0-5.98-1.77-5.98-4.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M440.18,37.43c0-1.99,1.82-3.03,3.28-3.42l-2.54-2.29v-3.07h9.67v2.67h-5.84l4.27,4.38c.11-.56.13-1.99.13-2.77h3.37c0,2.19-.53,3.76-1.12,4.98l3.57,3.48h-4.05l-1.27-1.31c-1.05.92-2.52,1.49-4.09,1.49-3.85,0-5.38-1.95-5.38-4.14h0ZM447.64,38.29l-2.3-2.21c-1.14.16-1.69.72-1.69,1.39,0,.84.52,1.43,1.84,1.43.66,0,1.55-.14,2.15-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M459.95,35.02c0-3.38,1.16-6.55,6.57-6.55,4.75,0,6.41,2.43,6.41,5.22h-3.59c-.22-1.67-.9-2.57-2.82-2.57-2.56,0-2.98,1.73-2.98,3.9s.39,3.9,2.98,3.9c1.95,0,2.6-.86,2.82-2.59h3.61c0,2.95-1.66,5.24-6.43,5.24-5.43,0-6.57-3.17-6.57-6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M474.75,35.74v-7.09h3.57v7.05c0,2.09.44,3.19,2.67,3.19s2.67-1.1,2.67-3.19v-7.05h3.59v7.09c0,4.08-1.84,5.83-6.26,5.83s-6.24-1.75-6.24-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M489.62,41.39v-12.74h3.57l-.04,10.11h4.66v2.63h-8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M499.96,41.39v-10.11h-3.52v-2.63h10.55v2.63h-3.52v10.11h-3.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M508.24,35.74v-7.09h3.57v7.05c0,2.09.44,3.19,2.67,3.19s2.67-1.1,2.67-3.19v-7.05h3.59v7.09c0,4.08-1.84,5.83-6.26,5.83s-6.24-1.75-6.24-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M523.06,41.39v-12.74h5.36c5.38,0,5.91,2.59,5.91,4.26,0,1.41-.53,3.62-3.87,3.8l4.49,4.68h-4.34l-4.01-4.82v4.82h-3.55ZM526.6,34.5h1.77c1.95,0,2.36-.86,2.36-1.59,0-.8-.42-1.63-2.36-1.63h-1.77v3.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M536.39,41.39v-12.74h10.13v2.63h-6.61v2.37h5.95v2.49h-5.95v2.63h6.61v2.63h-10.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M548.13,36.87h3.52c.07,1.29.61,2.15,2.65,2.15,1.82,0,2.25-.68,2.25-1.27,0-2.63-8.19-.5-8.19-5.42,0-1.95,1.29-3.86,5.74-3.86s5.67,1.91,5.73,4.5h-3.5c-.07-1.08-.42-1.95-2.39-1.95-1.64,0-2.06.6-2.06,1.13,0,2.33,8.1.38,8.1,5.42,0,1.83-1.07,4-5.89,4-4.36,0-5.98-1.77-5.98-4.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M440.61,59.57v-12.74h5.54c4.36,0,6.61,2.29,6.61,6.29s-2.41,6.45-6.85,6.45h-5.3ZM444.15,56.95h1.2c2.58,0,3.92-.74,3.92-3.84-.02-3.11-1.29-3.64-3.83-3.64h-1.29v7.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M455.92,52.37v-2.45c-1.23-.06-1.97-.5-1.97-1.63,0-1.31.94-1.63,2.25-1.63,1.42,0,2.36.48,2.19,1.79l-.5,3.92h-1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M458.56,59.57l4.95-12.74h4.47l4.95,12.74h-3.72l-.77-2.19h-5.38l-.77,2.19h-3.72ZM463.82,55.02h3.85l-1.95-5.38-1.9,5.38h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M473.98,59.57v-12.74h5.1l3.07,8.14c.2.52.37,1.12.44,1.37.07-.26.2-.86.39-1.37l3.15-8.14h5.06v12.74h-3.57v-8.74l-3.33,8.74h-3.39l-3.39-8.74v8.74h-3.52,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M493.8,59.57v-12.74h10.13v2.63h-6.61v2.37h5.95v2.49h-5.95v2.63h6.61v2.63h-10.13ZM494.52,45.82v-2.29l8.69-1.31v2.29l-8.69,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M505.95,59.57v-12.74h5.36c5.38,0,5.91,2.59,5.91,4.26,0,1.41-.53,3.62-3.87,3.8l4.49,4.68h-4.34l-4.01-4.82v4.82h-3.55ZM509.49,52.69h1.77c1.95,0,2.36-.86,2.36-1.59,0-.8-.42-1.63-2.36-1.63h-1.77v3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M519.28,59.57v-12.74h3.54v12.74h-3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M532.33,59.57c-6.22,0-7.42-2.79-7.42-6.37,0-3.38,1.2-6.55,6.76-6.55s6.81,3.17,6.81,6.57c0,2.23-.83,3.36-1.86,4.02l2.04.82v1.51h-6.33,0ZM534.87,53.22c0-2.19-.37-3.92-3.2-3.92s-3.17,1.71-3.17,3.9c0,2.31.55,3.76,3.17,3.76s3.2-1.45,3.2-3.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M540.44,53.92v-7.09h3.57v7.05c0,2.09.44,3.19,2.67,3.19s2.67-1.1,2.67-3.19v-7.05h3.59v7.09c0,4.08-1.84,5.83-6.26,5.83s-6.24-1.75-6.24-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M555.26,59.57v-12.74h10.13v2.63h-6.61v2.37h5.95v2.49h-5.95v2.63h6.61v2.63h-10.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M440.78,77.76v-12.74h5.54c4.36,0,6.61,2.29,6.61,6.29s-2.41,6.45-6.85,6.45h-5.3ZM444.33,75.13h1.2c2.58,0,3.92-.74,3.92-3.84-.02-3.11-1.29-3.64-3.83-3.64h-1.29v7.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M454.82,72.11v-7.09h3.57v7.05c0,2.09.44,3.19,2.67,3.19s2.67-1.1,2.67-3.19v-7.05h3.59v7.09c0,4.08-1.84,5.83-6.26,5.83s-6.24-1.75-6.24-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M474.4,77.76v-12.74h4.36l5.19,8.12v-8.12h3.57v12.74h-4.18l-5.34-8.08v8.08h-3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M489.64,71.39c0-3.38,1.2-6.55,6.76-6.55s6.81,3.17,6.81,6.57-1.2,6.53-6.81,6.53-6.76-3.17-6.76-6.55ZM499.6,71.41c0-2.19-.37-3.96-3.2-3.96s-3.17,1.77-3.17,3.94.42,3.9,3.17,3.9,3.2-1.71,3.2-3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M505.32,77.76v-12.74h5.36c5.38,0,5.91,2.59,5.91,4.26,0,1.41-.53,3.62-3.87,3.8l4.49,4.68h-4.34l-4.01-4.82v4.82h-3.55ZM508.86,70.87h1.77c1.95,0,2.36-.86,2.36-1.59,0-.8-.42-1.63-2.36-1.63h-1.77v3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M518.65,77.76v-12.74h5.54c4.36,0,6.61,2.29,6.61,6.29s-2.41,6.45-6.85,6.45h-5.3ZM522.2,75.13h1.2c2.58,0,3.92-.74,3.92-3.84-.02-3.11-1.29-3.64-3.83-3.64h-1.29v7.48h0Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M444.63,110.82l-5.45-14.11h4.12l3.78,10.98,3.88-10.98h4.12l-5.57,14.11h-4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M457.08,110.82v-14.11h3.93v14.11h-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M464.74,110.82v-14.11h4.82l5.74,8.99v-8.99h3.95v14.11h-4.63l-5.91-8.95v8.95h-3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M482.46,103.77c0-3.75,1.28-7.25,7.27-7.25,5.26,0,7.1,2.69,7.1,5.77h-3.97c-.24-1.85-.99-2.84-3.13-2.84-2.83,0-3.3,1.92-3.3,4.32s.44,4.32,3.3,4.32c2.16,0,2.88-.95,3.13-2.86h4c0,3.26-1.84,5.8-7.13,5.8-6.01,0-7.27-3.51-7.27-7.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M499.93,110.82v-14.11h11.22v2.91h-7.32v2.62h6.59v2.75h-6.59v2.91h7.32v2.91h-11.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M514.28,110.82v-14.11h4.82l5.74,8.99v-8.99h3.95v14.11h-4.63l-5.91-8.95v8.95h-3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M532.58,110.82v-14.11h4.82l5.74,8.99v-8.99h3.95v14.11h-4.63l-5.91-8.95v8.95h-3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M550.83,110.82v-14.11h11.22v2.91h-7.32v2.62h6.59v2.75h-6.59v2.91h7.32v2.91h-11.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M564.67,105.82h3.9c.07,1.43.68,2.38,2.93,2.38,2.01,0,2.5-.75,2.5-1.41,0-2.91-9.06-.55-9.06-6,0-2.16,1.43-4.27,6.35-4.27s6.28,2.11,6.35,4.98h-3.88c-.07-1.19-.46-2.16-2.64-2.16-1.82,0-2.28.66-2.28,1.25,0,2.58,8.97.42,8.97,6,0,2.03-1.19,4.43-6.52,4.43-4.82,0-6.62-1.96-6.62-5.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M440.47,130.31v-14.11h11.08v2.91h-7.17v3.17h6.64v2.75h-6.64v5.27h-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M454.14,130.31v-14.11h5.94c5.96,0,6.54,2.87,6.54,4.72,0,1.56-.58,4.01-4.29,4.21l4.97,5.18h-4.8l-4.44-5.33v5.33h-3.93ZM458.07,122.68h1.96c2.16,0,2.62-.95,2.62-1.76,0-.88-.46-1.81-2.62-1.81h-1.96v3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M468.05,130.31l5.48-14.11h4.94l5.48,14.11h-4.12l-.85-2.43h-5.96l-.85,2.43h-4.12ZM473.87,125.26h4.26l-2.16-5.95-2.11,5.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M486.01,130.31v-14.11h4.82l5.74,8.99v-8.99h3.95v14.11h-4.63l-5.91-8.95v8.95h-3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M503.73,123.25c0-3.75,1.28-7.25,7.27-7.25,5.26,0,7.1,2.69,7.1,5.77h-3.97c-.24-1.85-.99-2.84-3.13-2.84-2.83,0-3.3,1.92-3.3,4.32s.44,4.32,3.3,4.32c2.16,0,2.88-.95,3.13-2.86h4c0,3.26-1.84,5.8-7.13,5.8-6.01,0-7.27-3.51-7.27-7.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M521.2,130.31v-14.11h11.22v2.91h-7.32v2.62h6.59v2.75h-6.59v2.91h7.32v2.91h-11.22Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M402.17,87.45c0-4.43,1.77-8.15,8.15-8.15s8.15,3.72,8.15,8.17-1.69,8.17-8.15,8.17-8.15-3.7-8.15-8.19h0ZM416.51,87.47c0-3.7-1.31-6.48-6.18-6.48s-6.18,2.8-6.18,6.48,1.33,6.48,6.18,6.48,6.18-2.78,6.18-6.48h0ZM406.27,87.55c0-2.4.99-4.45,4.1-4.45,2.48,0,3.78,1.39,3.78,3.7h-1.83c-.12-1.43-.72-2.03-1.97-2.03-1.59,0-2.23,1.01-2.23,2.72s.64,2.76,2.23,2.76c1.25,0,1.87-.6,1.97-1.97h1.83c0,2.33-1.23,3.66-3.72,3.66-3.16,0-4.15-2.03-4.15-4.39h0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bd1f02ed20645d94509e429b0d32abec.svg";
export { ForwardRef as ReactComponent };